import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Section.css';

const Section = ({ title, subtitle, children, theme = 'light', id = '' }) => {
  const containerVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  return (
    <motion.section
      id={id}
      className={`section section-${theme}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      <div className="section-container">
        {(title || subtitle) && (
          <div className="section-header">
            {title && <h2 className="section-title">{title}</h2>}
            {subtitle && <p className="section-subtitle">{subtitle}</p>}
          </div>
        )}

        <div className="section-content">{children}</div>
      </div>
    </motion.section>
  );
};

export default Section;
